module.exports = __webpack_public_path__ + "static/media/imagen-trabajando-con-agricultores.d4685ca3.jpg";